import { Link } from "wouter";
import { INDEX_SYMBOL } from "../lib/data";

export default function HowItWorks() {
  const steps = [
    {
      id: "trade",
      title: "Trade",
      body: `Buys and sells of $${INDEX_SYMBOL} pay a 2% pool fee.`,
    },
    {
      id: "fees",
      title: "Fees",
      body: "Creator fees accrue to the treasury wallet automatically on StonkFun — the worker spends them when the liquid balance clears the gate.",
    },
    {
      id: "buy",
      title: "Buy board",
      body: "Claimed SOL buys the live weighted StonkFun basket.",
    },
    {
      id: "airdrop",
      title: "Airdrop",
      body: `Most fees buy the board for pro-rata airdrops (min 10K $${INDEX_SYMBOL}). ~10% funds an equal-odds SOL lottery on a random 20–60m clock.`,
    },
    {
      id: "rotate",
      title: "Rotate",
      body: "Scores refresh hourly — names enter and exit the board while payouts keep ticking.",
    },
  ];

  return (
    <section className="app-section how-section">
      <div className="shell">
        <div className="section-intro">
          <p className="section-kicker">
            <i className="brand-diamond" aria-hidden /> How it works
          </p>
          <h2 className="section-title">From fee to basket</h2>
          <p className="section-lead left">
            {`One loop funds the board. Hold $${INDEX_SYMBOL} to stay in the airdrop set when the basket rotates.`}
          </p>
        </div>

        <div className="how-stage" aria-hidden>
          <svg className="how-orbit" viewBox="0 0 640 280" role="presentation">
            <defs>
              <linearGradient id="howFlow" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#69aac1" stopOpacity="0.2" />
                <stop offset="50%" stopColor="#abf945" stopOpacity="0.9" />
                <stop offset="100%" stopColor="#69aac1" stopOpacity="0.2" />
              </linearGradient>
            </defs>
            <path
              className="how-path"
              d="M40 140 C 140 40, 240 40, 320 140 S 500 240, 600 140"
              fill="none"
              stroke="url(#howFlow)"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <circle className="how-pulse" r="7" fill="#abf945">
              <animateMotion
                dur="7s"
                repeatCount="indefinite"
                path="M40 140 C 140 40, 240 40, 320 140 S 500 240, 600 140"
              />
            </circle>
            <g className="how-nodes">
              {[40, 180, 320, 460, 600].map((x, i) => (
                <g key={steps[i].id} transform={`translate(${x} 140)`}>
                  <circle r="18" className={`how-node how-node--${i}`} />
                  <text textAnchor="middle" dy="4" className="how-node-label">
                    {i + 1}
                  </text>
                </g>
              ))}
            </g>
          </svg>
        </div>

        <ol className="how-steps">
          {steps.map((step, i) => (
            <li
              key={step.id}
              className="how-card"
              style={{ animationDelay: `${0.08 * i}s` }}
            >
              <span className="how-card__num">{String(i + 1).padStart(2, "0")}</span>
              <h3>{step.title}</h3>
              <p>{step.body}</p>
            </li>
          ))}
        </ol>

        <div className="how-loop" aria-hidden>
          <div className="how-loop__ring">
            <span>Score</span>
            <span>Weight</span>
            <span>Buy</span>
            <span>Pay</span>
          </div>
          <p>Basket weights follow StonkFun scores each refresh.</p>
        </div>

        <div className="section-actions" style={{ display: "flex", gap: "0.65rem", flexWrap: "wrap" }}>
          <Link href="/portfolio" className="btn btn-lime">
            Open portfolio
          </Link>
          <Link href="/basket" className="btn btn-ghost">
            Live basket
          </Link>
        </div>
      </div>
    </section>
  );
}
